module.exports = __webpack_public_path__ + "img/ali-pay.979417c.svg";